module.exports = __webpack_public_path__ + "icons/icon-intro.48f23c86.svg";